import toast from "react-hot-toast";
import { useEffect, useState, useCallback, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";

import { getAssignedContacts, updateContactCompanydetails } from "../../api/crm";

import NewForm210 from "../application/NewForm210";
import AssignContacts from "../assignContacts/AssignContacts";
import { useUser, useUserRefetch } from "../../hooks/useUser";
import { FacilityCompanyList } from "../consultant/FacilityCompanyList";
import AssignContactLoading from "../loaders/AssignContactLoading";

export const Form210 = (props) => {
  const { applicationID } = useParams();
  const [loading, setLoading] = useState(false);
  const [checkContactsAssigned, setCheckContactsAssigned] = useState(false);
  const [companySelected, setCompanySelected] = useState(false);
  const [assignedContacts, setAssignedContacts] = useState({
    signatory: "",
    primaryRepresentative: "",
    billingRepresentative: "",
    engineeringConsultant: "",
    engineeringConsultantCompany: "",
  });
  const [companyContactApplication, setCompanyContactApplication] = useState({});
  const location = useLocation();

  // Memoize query parameters to avoid recalculation
  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const companyID = queryParams.get("companyID");

  const user = useUser();
  const refetchUser = useUserRefetch();

  // Optimize checkContacts with useCallback
  const checkContacts = useCallback(async (applicationID, user) => {
    try {
      setLoading(true);
      const { data } = await getAssignedContacts(applicationID);
      if (data.status) {
        if (data.data) {
          const { primaryContact } = data.data;
          if (primaryContact) {
            setCheckContactsAssigned(true);
            setCompanyContactApplication(data.data);
          }
        }
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array since we pass parameters

  // Optimize checkCompanySelected with useCallback
  const checkCompanySelected = useCallback(async (user, companyContactApplication) => {
    if (user) {
      if (user.role.roleType === "CONSULTANT") {
        const { facilityCompany } = companyContactApplication;
        if (facilityCompany) {
          setCompanySelected(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    checkContacts(applicationID, user);
  }, [applicationID, user, checkContacts]);

  useEffect(() => {
    checkCompanySelected(user, companyContactApplication);
  }, [user, companyContactApplication, checkCompanySelected]);

  useEffect(() => {
    if (companyID) {
      handleSaveFacilityId(companyID, applicationID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyID, applicationID]);

  const handleSaveFacilityId = async (companyID, applicationID) => {
    const data = {
      applicationID,
      assignedContacts: {
        facilityCompany: companyID,
      },
    };
    await updateContactCompanydetails(data);
    localStorage.setItem("facilityId", "ALL");
    setCompanySelected(true);
    setCheckContactsAssigned(false);
    refetchUser();
  };

  const handleSave = async () => {
    setCheckContactsAssigned(true);
    const data = {
      applicationID,
      assignedContacts,
    };
    await updateContactCompanydetails(data);
  };

  const handleSaveFacility = async (facility) => {
    const data = {
      applicationID,
      assignedContacts: {
        facilityCompany: facility.id,
      },
    };
    await updateContactCompanydetails(data);
    localStorage.setItem("facilityId", "ALL");
    setCompanySelected(true);
    setCheckContactsAssigned(false);
  };

  if (loading || !user) {
    return <AssignContactLoading />;
  }

  if (user.role.roleType === "CONSULTANT") {
    if (!companySelected) {
      return <FacilityCompanyList user={user} onSave={handleSaveFacility} />;
    }
  }

  if (!checkContactsAssigned) {
    return <AssignContacts onSave={handleSave} setAssignedContacts={setAssignedContacts} companyContactApplication={companyContactApplication} />;
  }

  return <NewForm210 {...props} />;
};
